module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// McBlog_ShareThis Widget

(function (fox, $) {
	
	fox.registerWidget('McBlog_ShareThis', {

		init: function () {
			this.APIKEY = 'tze5hhkbpgnm9856eh5yu4tn';
			this.REQUESTURI = 'http://rest.sharethis.com/v1/share/share';

			this.addDomHandler(fox.merge({
				event: 'click',
				targetWidget: '@parent',
				callback: 'getLink'
			}, this.getOption('onShareClick')), 'onShareClick')
		
			this.callParent('init', arguments);
		},

		getLink: function (el, evAlias, scope) {
			var d, t, u, a, title, url;

			if (scope.getClass() === 'McBlog_PostWindow') {
				title = scope.POSTDATA.title;
				url = window.location.href;
			} else {
				title = scope.getOption('externalObj.title');
				url = [window.location.href, scope.getOption('externalObj.id')].join('/');
			}

			el = $(el);

			d = ['destination', el.data('destanation')].join('=');
			t = ['title', title].join('=');
			u = ['url', window.encodeURIComponent(url)].join('=');
			a = ['api_key', this.APIKEY].join('=');

			$(el).attr({
				'href': [this.REQUESTURI, [d, t, u, a].join('&')].join('?'),
				'target': '_blank'
			});

			return true;
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/sitepage/mcBlog/shareThis.js
// module id = 476
// module chunks = 2